import { render, staticRenderFns } from "./OsCard.vue?vue&type=template&id=dd01ef6e&scoped=true&"
import script from "./OsCard.vue?vue&type=script&lang=js&"
export * from "./OsCard.vue?vue&type=script&lang=js&"
import style0 from "./OsCard.vue?vue&type=style&index=0&id=dd01ef6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd01ef6e",
  null
  
)

export default component.exports